import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { LandingPage } from './pages/LandingPage'
import { LoginPage } from './pages/auth/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { TicketsPage } from './pages/tickets/TicketsPage'
// import { TicketDetailPage } from './pages/tickets/TicketDetailPage'
// import { TicketDetailsPage } from './pages/tickets/TicketDetailsPage'
import { EnhancedTicketDetailsPage } from './pages/tickets/EnhancedTicketDetailsPage'
import { MyTicketsPage } from './pages/tickets/MyTicketsPage'
import { AgentTicketsPage } from './pages/tickets/AgentTicketsPage'
import { NewTicketPage } from './pages/tickets/NewTicketPage'
import { ProfilePage } from './pages/ProfilePage'
import { AdminPage } from './pages/admin/AdminPage'
import { UsersPage } from './pages/admin/UsersPage'
import { CategoriesPage } from './pages/CategoriesPage'
import { PrioritiesPage } from './pages/admin/PrioritiesPage'
import { SLAPoliciesPage } from './pages/admin/SLAPoliciesPage'
import { WebhooksPage } from './pages/admin/WebhooksPage'
import { EmailTemplatesPage } from './pages/admin/EmailTemplatesPage'
import { FeedbacksPage } from './pages/admin/FeedbacksPage'
import { FeedbackPage } from './pages/FeedbackPage'
import { TicketReportsPage, PerformanceReportsPage, AgentActivityReportsPage } from './pages/admin/reports'
import { ArticlesPage as AdminArticlesPage } from './pages/admin/ArticlesPage'
import { ArticleEditorPage } from './pages/admin/ArticleEditorPage'
import { ArticlesPage } from './pages/ArticlesPage'
import { ArticleDetailPage } from './pages/ArticleDetailPage'
import { SLAInfoPage } from './pages/SLAInfoPage'
import { ContactSupportPage } from './pages/ContactSupportPage'
import { AccountSettingsPage } from './pages/AccountSettingsPage'
import { Layout } from './components/Layout'
import { LoadingSpinner } from './components/LoadingSpinner'
import { TicketCountProvider } from './contexts/TicketCountContext'

function App() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return <LoadingSpinner />
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    )
  }

  return (
    <TicketCountProvider>
      <Layout>
        <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/tickets" element={<TicketsPage />} />
        <Route path="/tickets/agent" element={<AgentTicketsPage />} />
        <Route path="/tickets/my" element={<MyTicketsPage />} />
        <Route path="/tickets/new" element={<NewTicketPage />} />
        <Route path="/tickets/:id" element={<EnhancedTicketDetailsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/articles" element={<ArticlesPage />} />
        <Route path="/articles/:slug" element={<ArticleDetailPage />} />
        <Route path="/sla-info" element={<SLAInfoPage />} />
        <Route path="/contact-support" element={<ContactSupportPage />} />
        <Route path="/account-settings" element={<AccountSettingsPage />} />
        {user.role === 'ADMIN' && (
          <>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/users" element={<UsersPage />} />
            <Route path="/admin/categories" element={<CategoriesPage />} />
            <Route path="/admin/priorities" element={<PrioritiesPage />} />
            <Route path="/admin/sla" element={<SLAPoliciesPage />} />
            <Route path="/admin/webhooks" element={<WebhooksPage />} />
            <Route path="/admin/email-templates" element={<EmailTemplatesPage />} />
            <Route path="/admin/feedbacks" element={<FeedbacksPage />} />
            <Route path="/admin/articles" element={<AdminArticlesPage />} />
            <Route path="/admin/articles/new" element={<ArticleEditorPage />} />
            <Route path="/admin/articles/:id/edit" element={<ArticleEditorPage />} />
            <Route path="/admin/reports/tickets" element={<TicketReportsPage />} />
            <Route path="/admin/reports/performance" element={<PerformanceReportsPage />} />
            <Route path="/admin/reports/agents" element={<AgentActivityReportsPage />} />
          </>
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
    </TicketCountProvider>
  )
}

export default App
